import { useOpportunityId } from 'domain/shared/opportunity';
import { useOpportunityUrl } from 'domain/sales/opportunity/opportunityRouting';
import { SidebarStickyMenu, SummaryMenuItem, ActivitiesMenuItem } from 'framework/ui/menu';

const OpportunityMenu = () => {
  const id = useOpportunityId();
  const { getTimelineUrl, getSingleEntityUrl } = useOpportunityUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl(id)} exact />
      <ActivitiesMenuItem linkUrl={getTimelineUrl(id)} />
    </SidebarStickyMenu>
  );
};

export default OpportunityMenu;
